import { createDomainApi, createFilespaceApi } from '../utils/createApi';
import { Domain, Filespace, VerificationCode } from 'fs-api-client';
import { errorHandler } from './errorHandler';

async function executeApiMethod<T>(
    createApi: () => any,
    apiMethodName: string,
    ...apiMethodArgs: any
): Promise<T> {
    try {
        const api = await createApi();
        return await api[apiMethodName](...apiMethodArgs);
    } catch (error) {
        errorHandler(error);
        throw error;
    }
}

export async function getDomain() {
    return (await executeApiMethod(createDomainApi, 'getDomains') as any).body[0];
}

export async function createDomain(domain: Domain) {
    return executeApiMethod(createDomainApi, 'createDomain', domain);
}

export async function updateDomain(domainId: string, domain: Domain) {
    return executeApiMethod(createDomainApi, 'updateDomain', domainId, domain);
}

export async function createFilespace(filespace: Filespace) {
    return executeApiMethod(createFilespaceApi, 'createFilespace', filespace);
}

export async function getFilespaces() {
    return (await executeApiMethod(createFilespaceApi, 'getFilespaces') as any).body;
}

export async function deleteFilespace(filespaceId: string, verificationCode?: VerificationCode ) {
    return executeApiMethod(
        createFilespaceApi,
        'deleteFilespace',
        filespaceId,
        verificationCode
    );
}

export async function renameFilespace(id: string, newName: string, verificationCode?: VerificationCode) {
    return executeApiMethod(createFilespaceApi, 'renameFilespace', id, newName, verificationCode);
}



// WEBPACK FOOTER //
// ./src/webportal/services/filespace.ts